/*
 * @Author: KellyYang
 * @Date: 2022-06-30 14:02:25
 * @LastEditors: KellyYang
 * @Description: 联系我们
 */
import React, { Fragment } from "react";
import logo from "@/assets/img/about-page/logo.png";
import './index.less'

const contactList = [
  {
    name: '地址：海南海口市龙华区金贸中路1号半山花园海天阁2328室'
  },
  {
    name: '电话：0898-68507057'
  },
  {
    name: '邮箱：sale@jinyucredit.com'
  }
]
const ContactUs = () => {
  return (
    <Fragment>
      <div className="contact-us-container">
        <div className="contact-us-content">
          <div className="contact-us-content-header">
            <img src={logo} alt="logo" />
            <div className="contact-us-content-header-content">
              <span>联系我们</span>
              <span>CONTACT US</span>
            </div>
          </div>
          <div className="contact-us-content-body">
            {
              contactList.map((item, index) => {
                return (
                  <span key={index} className="span" mode="smooth">{item.name}</span>
                )
              })
            }
          </div>
        </div>
      </div>
    </Fragment>
  )
}
export default ContactUs;
